import React from 'react';
import { motion } from 'framer-motion';
import { skills } from '../data/mock';
import { fadeInUp, staggerContainer } from '../lib/animations';

const Skills = () => {
  const skillCategories = [
    { title: 'Front-End', skills: skills.frontend, color: 'cyan' },
    { title: 'Back-End', skills: skills.backend, color: 'blue' },
    { title: 'Database', skills: skills.database, color: 'teal' },
    { title: 'Tools', skills: skills.tools, color: 'cyan' }
  ];

  return (
    <section id="skills" className="relative py-32 bg-gradient-to-b from-[#0a0a0a] via-[#0f0f10] to-[#0a0a0a]">
      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <h2 className="text-5xl sm:text-6xl font-bold mb-6">
            <span className="bg-gradient-to-r from-white to-cyan-400 bg-clip-text text-transparent">
              Skills & Technologies
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            A comprehensive toolkit for building modern web applications
          </p>
        </motion.div>

        {/* Skills Grid */}
        <motion.div
          variants={staggerContainer}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true, margin: "-100px" }}
          className="grid grid-cols-1 md:grid-cols-2 gap-8"
        >
          {skillCategories.map((category, catIndex) => (
            <motion.div
              key={catIndex}
              variants={fadeInUp}
              className="p-8 bg-white/5 rounded-2xl border border-white/10 backdrop-blur-sm"
            >
              <h3 className="text-2xl font-bold text-white mb-6">
                {category.title}
              </h3>
              <div className="flex flex-wrap gap-3">
                {category.skills.map((skill, skillIndex) => (
                  <motion.span
                    key={skillIndex}
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: skillIndex * 0.05 }}
                    whileHover={{ scale: 1.05, y: -2 }}
                    className="px-4 py-2 bg-gradient-to-br from-cyan-500/10 to-blue-500/10 border border-cyan-500/30 rounded-lg text-gray-200 text-sm font-medium hover:border-cyan-500/60 hover:shadow-[0_0_15px_rgba(6,182,212,0.3)] transition-all duration-300 cursor-default"
                  >
                    {skill}
                  </motion.span>
                ))}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Skills;